<div class="my-2">
    <div class="flex justify-between items-center bg-gray-200 py-1 px-2 rounded-2xl border border-gray-600" (click)="toggleAccordion()">
        <div class="flex flex-col">
          @if (translate) {
            <span class="text-lg font-bold">{{ header | language: 'sw' }}</span>
            <span class="text-sm">{{ header | language: 'en' }}</span>
          } @else {
            <span class="text-lg font-bold">{{ header }}</span>
          }
        </div>
        <div>
            <span *ngIf="viewAccordion">
            <mat-icon svgIcon="arrow-down-circle" style="height: 24px; width: 24px;"></mat-icon>
            </span>
            <span *ngIf="!viewAccordion">
                <mat-icon svgIcon="arrow-right-circle" style="height: 24px; width: 24px;"></mat-icon>
            </span>
        </div>
    </div>
    <div class="mt-1">
        <div class=" border rounded-2xl mt-1 px-2 py-1 flex flex-col" [ngClass]="{'hidden': !viewAccordion, 'block': viewAccordion}">
            @if (translate) {
              <span>{{ content | language: 'sw' }}</span>
              <span class="text-xs">{{ content | language: 'en' }}</span>
            } @else {
              <span>{{content}}</span>
            }
        </div>
    </div>
</div>
